import { forwardRef } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const Input = forwardRef(function Input(
  {
    label,
    className,
    labelClassName,
    inputClassName,
    type = "text",
    disabled,
    ...rest
  },
  ref,
) {
  return (
    <>
      <label
        className={clsx(
          "group w-full flex flex-col gap-x-2 gap-y-2 xs:items-left xs:flex-col",
          className,
        )}
      >
        {label && (
          <span
            className={clsx(labelClassName ? labelClassName : "xs:min-w-24")}
          >
            {label}
          </span>
        )}
        <input
          {...rest}
          disabled={disabled}
          type={type}
          ref={ref}
          className={clsx(
            inputClassName
              ? inputClassName
              : "px-3 py-2 text-sm border-0 ring-1 ring-black/20 dark:ring-white/20 focus:ring-green-500 dark:focus:ring-lime-500 bg-white dark:bg-white/10 placeholder-black/40 dark:placeholder-white/40 dark:text-zinc-300 rounded-primary",
            disabled &&
              "cursor-not-allowed opacity-60 bg-zinc-100 dark:bg-white/30 dark:text-zinc-200",
          )}
        />
      </label>
    </>
  );
});

Input.propTypes = {
  label: PropTypes.node,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
};

export default Input;
